/**
 * WS-HF wave 3, fix 12 — the key a case job is remembered under across a reload.
 *
 * The wizard store is memory: a reload empties it, and the operator picks the same three
 * photographs and presses Start again. `deviceRunRegistry` already remembers a generation job
 * per design hash in `localStorage` for exactly this reason (N1); a case job is remembered the
 * same way, under the hash of its three inputs, so that press RESUMES the job instead of
 * creating — and paying for — a second one.
 *
 * The three byte strings are joined with their lengths in front, so `(ab, c)` and `(a, bc)`
 * cannot hash alike.
 */
import { runKey } from "../generate/deviceRunRegistry.js";

export async function caseRunKey(phone: Uint8Array, empty: Uint8Array, crop: Uint8Array): Promise<string> {
  const parts = [phone, empty, crop];
  const total = parts.reduce((n, p) => n + 4 + p.length, 0);
  const all = new Uint8Array(total);
  let at = 0;
  for (const p of parts) {
    const len = p.length;
    all[at++] = (len >>> 24) & 0xff;
    all[at++] = (len >>> 16) & 0xff;
    all[at++] = (len >>> 8) & 0xff;
    all[at++] = len & 0xff;
    all.set(p, at);
    at += len;
  }
  return runKey(all, "case-job");
}
